<div class="main-header">
  <!-- <div (click)="sharedFb()">
    fb
  </div> -->
  <div class="header-logotype">
    <figure (click)="goHome()">
      <img style="max-height: 100px;" [src]="primaryLogo" *ngIf="primaryLogo" alt="" (load)="onImageLoad($event)" [style.height.px]="calculatedHeight">
      <img [src]="secondaryLogo" *ngIf="primaryLogo && secondaryLogo" alt="" class="secondary-logo">
      <img *ngIf="!environment.production" class="test-env" src="/assets/img/wip.png" alt="test environment">
    </figure>
  </div>
  <div class="header-title row">
    <div [ngClass]="{'col-12':!(primaryLogo && secondaryLogo),'col-md-8':primaryLogo && secondaryLogo}">
      <h5 *ngIf="titleService.getTitle() && authService.sessionActive()" class="d-none d-md-block">
        {{titleService.getTitle()}}</h5>
    </div>
  </div>
  <div class="header-nav">
    <app-nav [orientation]="'horizontal'" *ngIf="!authService.sessionActive()"></app-nav>
    <!-- Session active -->
    <div>
      <ul *ngIf="authService.sessionActive() && userName" class="container-menu-profile justify-content-end font-weight-bold">
        <li class="profile-data">
          <a>
            Hola , {{userName}}
          </a>
          <a class="link-sign-out" (click)="openModalConfirmLogOut(modalConfirmLogOut)">Cerrar sesión</a>
        </li>
        <li class="nav-rndc-alert"
          *ngIf="rndcContingency && authService.hasTransportServicesCompany">
          <app-alertrndc></app-alertrndc>
        </li>
        <li class="nav-notifications">
          <a>
            <button mat-button class="button bell-button"
              [matMenuTriggerFor]="menu"
              #notificationsMenuTrigger="matMenuTrigger"
              [attr.aria-label]="unreadNotifications > 0 ? 'Notificaciones (' + unreadBadgeLabel() + ' sin leer)' : 'Notificaciones'">
              <span class="bell-icon-wrap">
                <i class="far fa-bell"></i>
                <span class="bell-badge"
                  *ngIf="unreadNotifications > 0"
                  [class.bell-badge--dot]="unreadNotifications > 99"
                  aria-hidden="true">
                  {{ unreadBadgeLabel() }}
                </span>
              </span>
            </button>
            <mat-menu class="container-notifications" panelClass="container-notifications"
              xPosition="before" [overlapTrigger]="false"
              (menuOpened)="refreshNotificationsMenu()"
              #menu="matMenu" backdropClass="menu-notifications">
              <app-user-notifications
                (closeRequested)="notificationsMenuTrigger.closeMenu()"></app-user-notifications>
            </mat-menu>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="gps-tracking-alert-container" *ngIf="showGpsAlert">
  <app-gps-tracking-alert [notification]="notification" (close)="onGpsAlertClose()"></app-gps-tracking-alert>
</div>



<ng-template #modalConfirmLogOut let-modal>
  <div class="modal-body wrapper-modal">
    <p class="title">
      ¿Estás seguro que deseas <br> cerrar esta sesión?
    </p>
    <mat-card-actions>
      <button mat-raised-button class="primary-secondary" color="primary"
        (click)="closeModalConfirmLogOut()">No</button>
      <button mat-raised-button color="primary" (click)="logOut()">Si</button>
    </mat-card-actions>
  </div>
</ng-template>
